// a no-op reducer that can be used for things that do not change on the frontend
export default (state = null) => state
